import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import * as React from 'react';
import {Route} from '@react-navigation/native';
import {useEffect} from 'react';
import {getPollsList} from '../../redux/actions/polls/list';
import {surveysListSelector, votesListSelector} from '../../redux/selectors/polls';

type ResolverProps = {route: Route<string>} & any;

export const PollsResolver = (viewComponent: React.FC<any>) => {
  return function Resolver(props: ResolverProps) {
    const dispatch = useAppDispatch();
    const polls = useSelector(surveysListSelector());
    const votes = useSelector(votesListSelector());

    useEffect(() => {
      if (polls === null || votes === null) {
        dispatch(getPollsList());
      }
    }, [polls, votes]);

    // if (polls === null || votes === null) {
    //   return null;
    // }

    return React.createElement(viewComponent, props);
  };
};
